import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  NbActionsModule,
  NbAlertModule,
  NbButtonModule,
  NbCardModule,
  NbIconModule,
  NbSpinnerModule,
} from '@nebular/theme';
import { LetDirective } from '@ngrx/component';
import { FormlyModule } from '@ngx-formly/core';
import { FormFieldsAutocompleteModule } from '@vmspdb/components/form-fields/autocomplete';
import { FormFieldsDateRangePickerModule } from '@vmspdb/components/form-fields/daterangepicker';
import { FormFieldsDatetimepicker2Module } from '@vmspdb/components/form-fields/datetimepicker2';
import { FormFieldsSelectAutocompleteModule } from '@vmspdb/components/form-fields/select-autocomplete';
import { FormFieldsTimepickerModule } from '@vmspdb/components/form-fields/timepicker';
import {
  FormatSurveyTaskGenericPipe,
  VmsPipesModule,
} from '@vmspdb/components/pipes';
import { UICommonModule } from '@vmspdb/ui/common';
import { FatalErrorComponent } from './components/fatal-error/fatal-error.component';
import { GlobalTimeTrackingHeaderComponent } from './components/time-tracking-header/global-time-tracking-header.component';
import { GlobalTimeTrackingModalComponent } from './components/time-tracking-modal/global-time-tracking-modal.component';
import { GlobalTimeTrackingOfficeModalComponent } from './components/time-tracking-office-modal/global-time-tracking-office-modal.component';

@NgModule({
  declarations: [
    GlobalTimeTrackingHeaderComponent,
    GlobalTimeTrackingModalComponent,
    GlobalTimeTrackingOfficeModalComponent,
    FatalErrorComponent,
  ],
  imports: [
    CommonModule,
    NbActionsModule,
    NbButtonModule,
    NbIconModule,
    LetDirective,
    NbAlertModule,
    UICommonModule,
    ReactiveFormsModule,
    FormlyModule,
    FormFieldsAutocompleteModule,
    FormFieldsSelectAutocompleteModule,
    FormFieldsDatetimepicker2Module,
    FormFieldsTimepickerModule,
    FormFieldsDateRangePickerModule,
    NbCardModule,
    NbSpinnerModule,
    FormatSurveyTaskGenericPipe,
    VmsPipesModule,
  ],
  exports: [
    GlobalTimeTrackingHeaderComponent,
    GlobalTimeTrackingModalComponent,
    GlobalTimeTrackingOfficeModalComponent,
  ],
})
export class GlobalModule {}
